import EmptyList from "./EmptyList";

export default EmptyList;
